import classNames from 'classnames';
import { ComponentProps, createContext, KeyboardEvent, MouseEvent, useContext } from 'react';
import { MdLock } from 'react-icons/md';
import { Link, LinkProps } from 'react-router-dom';
import NavBarBadge, { NavBarBadgeProps } from '../NavBarBadge/NavBarBadge';
import styles from './NavBarMenuContentItem.module.scss';

const NavBarMenuItemContext = createContext({ isDisabled: false });

const NavBarMenuItemBadge = ({ skin, className, ...props }: NavBarBadgeProps) => {
  const { isDisabled } = useContext(NavBarMenuItemContext);
  return <NavBarBadge className={classNames(styles['badge'], className)} skin={isDisabled ? 'grey' : skin} {...props} />;
};

const NavBarMenuContentItemLabel = ({ className, ...props }: ComponentProps<'span'>) => <span {...props} />;

type NavBarMenuContentItemProps = LinkProps & {
  isDisabled?: boolean;
  blockNavigation?: boolean;
  'data-testid'?: string;
};

const NavBarMenuContentItem = ({ to, children, className, isDisabled = false, blockNavigation = false, 'data-testid': testId }: NavBarMenuContentItemProps) => {
  // O clique do mouse chega ao item da lista (o link bloqueado nao recebe ponteiro);
  // aqui se barra o clique que chega ao link e o Enter, que o navegador vira clique.
  const preventClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (blockNavigation) event.preventDefault();
  };
  const preventEnter = (event: KeyboardEvent<HTMLAnchorElement>) => {
    if (blockNavigation && event.key === 'Enter') event.preventDefault();
  };

  return (
    <NavBarMenuItemContext.Provider value={{ isDisabled }}>
      <Link
        to={to}
        className={classNames(styles['wrapper'], isDisabled && styles['wrapper-disabled'], className)}
        aria-disabled={isDisabled || undefined}
        data-testid={testId}
        onClick={preventClick}
        onKeyDown={preventEnter}
      >
        {children}
        {isDisabled && <MdLock className={styles['lock-icon']} color="#959595" size={16} />}
      </Link>
    </NavBarMenuItemContext.Provider>
  );
};

export default {
  Root: NavBarMenuContentItem,
  Badge: NavBarMenuItemBadge,
  Label: NavBarMenuContentItemLabel,
};
